import { useMemo } from 'react'
import { useGetCurrentUserQuery } from '../../../core/api/UserApi'
import { AllRoutes } from '../../../core/routes/AllRoutes'
import BurgerMenu, { IBurgerData } from '../../../widgets/burgerMenu/BurgerMenu'
import CurrentDate from '../../../components/currentDate/CurrentDate'
import { useAppSelector } from '../../../core/store/store'
import { Role } from '../../../core/api/dto/UserDto'

const burgerDataBuffetLineAll: IBurgerData[] = [
  {
    id: 1,
    title: 'Блюда',
    ico: 'dish',
    to: `${AllRoutes.dishes.path}`,
  },
  {
    id: 2,
    title: 'Категории блюд',
    ico: 'categories',
    to: AllRoutes.categories.path,
  },
  { id: 3, title: 'Тары', ico: 'container', to: AllRoutes.millet.path },
  {
    id: 4,
    title: 'Шаблоны план-меню',
    ico: 't-menu-plan',
    to: AllRoutes.templatePlanMenu.path,
  },
  {
    id: 5,
    title: 'Типы план-меню',
    ico: 'type-plan-menu',
    to: AllRoutes.planMenuType.path,
  },
  {
    id: 24,
    title: 'Тип несоответствия',
    ico: 'type-mismatch',
    to: AllRoutes.typeMismatch.path,
  },
  { id: 6, title: 'План-меню', ico: 'plan-menu', to: AllRoutes.planMenu.path },
  {
    id: 23,
    title: 'Отчёты',
    ico: 'report-heart',
    to: AllRoutes.buffetReportsVZ.path,
  },
  {
    id: 15,
    title: 'Сравнительный отчет',
    ico: 'report-heart',
    to: AllRoutes.buffetComparativeReports.path,
  },
  {
    id: 9,
    title: 'Контроль план-меню',
    ico: 'control-plan-menu',
    to: AllRoutes.planMenuControl.path,
  },
  {
    id: 10,
    title: 'Контроль зала',
    ico: 'control-plan-menu',
    to: AllRoutes.planMenuControlManager.path,
  },
  {
    id: 11,
    title: 'Закрытие план-меню',
    ico: 'close-plan-menu',
    to: AllRoutes.planMenuClose.path,
  },
  { id: 12, title: 'Хэштеги', ico: 'hashtag', to: AllRoutes.tags.path },
  {
    id: 14,
    title: 'Тип гостя',
    ico: 'user-circle',
    to: AllRoutes.guestType.path,
  },
  { id: 19, title: 'Настройки', ico: 'settings', to: AllRoutes.options.path },
]

export const burgerDataBuffetLineByRole: { [key in Role]: number[] } = {
  SUPERVISOR: [1, 2, 3, 4, 5, 6, 9, 10, 11, 12, 14, 15, 19, 20, 23, 24],
  ADMINISTRATOR: [1, 2, 3, 4, 5, 6, 9, 10, 11, 12, 14, 15, 19, 20, 23, 24],
  MANAGER: [10, 11, 19, 20],
  ACCOUNTANT: [1, 2, 3, 4, 5, 6, 19, 20, 23],
  COOK: [1, 2, 3, 6, 19, 20, 23],
  CONTROLLER: [6, 19, 20, 23],
}

export const HeaderBuffetLinePage = () => {
  const token = useAppSelector((state) => state.foodBoxAuth.token)
  const { data: currentUser } = useGetCurrentUserQuery({}, { skip: !token })
  const burgerData: IBurgerData[] = useMemo(() => {
    return burgerDataBuffetLineAll.filter((item) =>
      currentUser?.userRoles.roleType
        .map((roleItem) => burgerDataBuffetLineByRole[roleItem as Role])
        .reduce((acc, el) => [...acc, ...el], [])
        .some((i) => i === item.id),
    )
  }, [currentUser])

  return (
    <header className="header admin">
      <BurgerMenu burgerData={burgerData} currentUser={currentUser} />
      <div className="container-fluid">
        <div className="wrapper-heading">
          <h4 className="color-White text-center">
            {currentUser?.userRoles.restaurant.name}
          </h4>
          <h4 className="color-White text-end">
            <CurrentDate />
          </h4>
        </div>
      </div>
    </header>
  )
}
